module.exports = __webpack_public_path__ + "img/people_mission.66f19bf2.png";